<tickets-badge-button [count]="tickets().length" (open)="openTicketsDialog()" />
